module.exports = "pegasus/assets/email1-column-6.png";